// extracted by mini-css-extract-plugin
export default {"highlight":"useMagneticWallSheetContext-module__highlight--zVLwu","image":"useMagneticWallSheetContext-module__image--XpZ8x"};